import React from 'react';
import {UIView} from '@uirouter/react';

const NknMain = ( props ) => <UIView></UIView>;
export default NknMain;
